import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const notificacionService = {
  sendNotificationBydIdUsuarioRange,
  insertOrUpdate,
  getAllByIdUsuario,
  setVisibilidad,
}

async function sendNotificationBydIdUsuarioRange(body) {
  return await ApiBudgety.post('Notificacion/SendNotificationBydIdUsuarioRange/', body, {
    headers: {
      ACCION: MenusSistema.permisos_usuario.accesos.enviar_difucion,
      MENU: MenusSistema.permisos_usuario.id,
    },
  })
}

async function insertOrUpdate(body) {
  return await ApiBudgety.post('Notificacion/insertOrUpdate/', body)
}

async function getAllByIdUsuario(idUsuario, limit) {
  return await ApiBudgety.get('Notificacion/GetAllByIdUsuario/' + idUsuario + '/' + limit)
}

async function setVisibilidad(id) {
  return await ApiBudgety.get('Notificacion/ToggleVisibleById/' + id)
}
